import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import PropertyThumbnail from "./PropertyThumbnail";
import LoadingMessage from "../LoadingMessage";
import { startGetLatestProperties } from "../../actions/properties";
import ErrorMessage from "../ErrorMessage";

function LatestProperties(props) {
  const dispatch = useDispatch();
  const isLoading = useSelector(
    (state) => state.property.latestProperties.loading
  );
  const loadedProperties = useSelector(
    (state) => state.property.latestProperties.data
  );
  const errorDesc = useSelector(
    (state) => state.property.latestProperties.error
  );

  useEffect(() => {
    dispatch(startGetLatestProperties());
  }, []);

  if (isLoading) {
    return <LoadingMessage></LoadingMessage>;
  } else if (
    loadedProperties !== undefined &&
    loadedProperties != null &&
    loadedProperties.length >= 0
  ) {
    return (
      <section className="slice sct-color-1">
        <div className="container">
          <div className="row-wrapper">
            <div className="row">
              {loadedProperties.map((property) => (
                <PropertyThumbnail key={property.id} data={property} />
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  } else {
    return (
      <>
        <ErrorMessage message={errorDesc} />
      </>
    );
  }
}

export default LatestProperties;
